import api from "../store/services/api";

export const getOperationOrdersCoordinates = async (params) =>
  await api.get(`/orders/current/coordinates/`, {
    params,
  });

export const getOperationOrdersAveragePreparationTime = async (params) =>
  await api.get(`/orders/current/preparation-time/`, {
    params,
  });

export const getOperationOrdersSalesPrediction = async (params) =>
  await api.get(`/orders/current/prediction/`, {
    params,
  });

const XrayService = {
  getOperationOrdersCoordinates,
  getOperationOrdersAveragePreparationTime,
  getOperationOrdersSalesPrediction,
};

export default XrayService;
